import { render, staticRenderFns } from "./bankArchiveBottom.vue?vue&type=template&id=a717af60"
import script from "./bankArchiveBottom.vue?vue&type=script&lang=js"
export * from "./bankArchiveBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports